import { usePlanSetTableQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
  createdAt: DateTime;
  updatedAt: DateTime;
  planCount: number;
}

export function useQuery(projectId: string) {
  const tuple = usePlanSetTableQuery({
    variables: {
      options: {
        filter: {
          projectId
        }
      }
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.planSets.map((node) => ({

        id: node.id ?? '',
        name: node.name ?? '',
        displayName: node.displayName ?? '',
        createdAt: node.createdAt,
        updatedAt: node.updatedAt,
        planCount: node.planCount ?? 0
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
